var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-availability",class:{ 'c-availability--active': _vm.isAvailable }},[_c('the-svg-icon',{attrs:{"name":_vm.state.name,"is-common":_vm.isCommon,"size-w":24}}),_vm._v(" "+_vm._s(_vm.state.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }